var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container"},[_c('Headline',[_vm._v("いぎなり東北産 Favorits")]),_c('Breadcrumb',[_c('BreadcrumbItem',{attrs:{"href":"/"}},[_vm._v("Top")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }